export default class URLRequest {
  public url: string;

  constructor(url: string = null) {
    this.url = url;
  }
}
